<!-- src/components/EmptyTriggerBox.svelte
     v11 step 4 — 純高度盒,給鏡頭飛行 / 揭幕 / 滾動緩衝用
     props:
       boxHeight: number  - vh 高度(在 ArchieML 的 path_transition 用 content 欄位填)
-->
<script>
  export let boxHeight = 200
</script>

<style>
  .empty-trigger-wrap {
    height: var(--box-height);
    margin: 0 auto;
    width: 100%;
  }

  /* 桌面版稍微長一點(滾動更舒緩) */
  @media (min-width: 650px) {
    .empty-trigger-wrap {
      height: calc(var(--box-height) * 1.3);
    }
  }
</style>

<div class="empty-trigger-wrap" style="--box-height: {boxHeight}vh" />
